/* istanbul ignore file */
export { default } from './TrustPilotReviews';
